import React from "react"
import {
  THaisyaListGetReq,
  T配車,
  T車輌乗務員,
} from "../../../service/order/haisya/THaisya"

export const ZyomuinListContext = React.createContext(
  {} as {
    車輌乗務員List: T車輌乗務員[]
    set車輌乗務員List: (v: T車輌乗務員[]) => unknown
  }
)

export const MihaisyaListContext = React.createContext(
  {} as {
    未配車List: T配車[]
    set未配車List: React.Dispatch<React.SetStateAction<T配車[]>>
  }
)

export const SelectCellContext = React.createContext(
  {} as {
    chip: string
    setChip: (v: string) => unknown
    selectKey: string
    setSelectKey: React.Dispatch<React.SetStateAction<string>>
    setSelectData: (props: {
      積日: string
      車輌乗務員: T車輌乗務員
      受注配車?: T配車[]
    }) => unknown
    isModalShow: boolean
    setIsModalShow: (v: boolean) => unknown
  }
)

export const SearchConditionContext = React.createContext<THaisyaListGetReq>(
  {} as THaisyaListGetReq
)
export const CalenderSearchContext = React.createContext<Function>(() => {})
export const MihaisyaSearchContext = React.createContext<Function>(() => {})
